var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.037,
    height: 23.037,
    viewBox: "0 0 23.037 23.037",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(-43 -2044.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-email",
    "data-name": "Icon material-email",
    d: "M14.943,6H4.327a1.325,1.325,0,0,0-1.32,1.327L3,15.289a1.331,1.331,0,0,0,1.327,1.327H14.943a1.331,1.331,0,0,0,1.327-1.327V7.327A1.331,1.331,0,0,0,14.943,6Zm0,2.654L9.635,11.971,4.327,8.654V7.327l5.308,3.317,5.308-3.317Z",
    transform: "translate(44.873 2044.329)",
    fill: "none",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    transform: "translate(43 2044.458)",
    fill: "none",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.519,
    cy: 11.519,
    r: 11.519,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.519,
    cy: 11.519,
    r: 11.169,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5dd76235eb0cec425891fac602b2f0df.svg";
export { ForwardRef as ReactComponent };